import { render } from "./GlobalSnack.vue?vue&type=template&id=7f0efcbb&scoped=true&lang=pug"
import script from "./GlobalSnack.vue?vue&type=script&lang=js"
export * from "./GlobalSnack.vue?vue&type=script&lang=js"

import "./GlobalSnack.vue?vue&type=style&index=0&id=7f0efcbb&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f0efcbb"]])

export default __exports__